module.exports = __webpack_public_path__ + "img/sk-partners-biznis_klub.2e10baa9.png";